import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["description"];
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React, { forwardRef } from 'react';
import useUniqueId from 'hooks/useUniqueId';
var MarkdownIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var description = _ref.description,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var descriptionId = useUniqueId();
  return /*#__PURE__*/React.createElement("svg", _extends({}, otherProps, {
    ref: ref,
    role: "img",
    viewBox: "0 0 208 128",
    style: {
      fill: 'currentcolor',
      width: 26,
      height: 16
    },
    "aria-label": "Markdown",
    "aria-describedby": descriptionId
  }), /*#__PURE__*/React.createElement("desc", {
    id: descriptionId
  }, description), /*#__PURE__*/React.createElement("path", {
    role: "presentation",
    d: "M208,25c0,-13.798 -11.202,-25 -25,-25c0,0 -158,0 -158,0c-13.798,0 -25,11.202 -25,25c0,0 0,78 0,78c0,13.798 11.202,25 25,25l158,0c13.798,0 25,-11.202 25,-25c0,-0 0,-78 0,-78Zm-10,0l0,78c0,8.279 -6.721,15 -15,15c0,0 -158,0 -158,0c-8.279,0 -15,-6.721 -15,-15l0,-78c0,-8.279 6.721,-15 15,-15l158,0c8.279,0 15,6.721 15,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    role: "presentation",
    d: "M30,98l0,-68l20,0l20,25l20,-25l20,0l0,68l-20,0l0,-39l-20,25l-20,-25l0,39l-20,0Zm125,0l-30,-33l20,0l0,-35l20,0l0,35l20,0l-30,33Z"
  }));
});
MarkdownIcon.displayName = 'MarkdownIcon';
export default MarkdownIcon;